export function readInitialRegistrationStep() {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("auth-return") === "member" || params.get("registration-step") === "profile" ? 1 : 0;
  } catch {
    return 0;
  }
}
